export default {"src":"https://fishbrain.com/_next/static/media/imagePlaceholder.11cad1d8.svg","height":282,"width":375,"blurWidth":0,"blurHeight":0};